import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useTranslation } from "../services/translation.service";

/**
 * Covers the UI while `dir` / translations settle after a language change,
 * so RTL and LTR layouts don't flash mid-reflow.
 */
const LanguageSwitchOverlay: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onStart = () => setVisible(true);
    const onSettled = () => setVisible(false);
    window.addEventListener("languageSwitching", onStart);
    window.addEventListener("languageSwitchSettled", onSettled);
    return () => {
      window.removeEventListener("languageSwitching", onStart);
      window.removeEventListener("languageSwitchSettled", onSettled);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[200000] flex items-center justify-center bg-white/80 backdrop-blur-sm"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-[#E53935]" />
        <span className="text-sm font-medium text-gray-600">
          {t("common.loading")}
        </span>
      </div>
    </div>
  );
};

export default LanguageSwitchOverlay;
